import { Component, ViewChild, ElementRef } from "@angular/core";
import { BaseListComponent } from "../../SharedModule/BaseListComponent/base-list.component";
import { RevenueService } from "../../services/revenue.service";
import { ProductCategoryService } from "../../services/product-category.service";
import { PrintService } from "../../services/print.service";
import { RevenueDataSource } from "../../model/DataSources/RevenueDataSource";
import { Pagination } from "../../model/Helpers/Pagination";
import { SortInfo } from "../../model/Helpers/SortInfo";
import { Filter } from "../../model/Helpers/Filter";
import { ProductCategory } from "../../model/Entities/ProductCategory";
import { MatSort } from "@angular/material/sort";
import { merge } from "rxjs/observable/merge";
import { Observable } from "rxjs/Observable";
import { CurrencyPipe } from "@angular/common";

@Component({
    selector: "revenue-per-product",
    templateUrl: "./revenue-per-product.component.html",
})
export class RevenuePerProductComponent extends BaseListComponent {
    displayedColumns: string[] = ["name", "count", "total_revenue"];

    categories: ProductCategory[] = [];

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild("search") search: ElementRef;

    constructor(
        private revenueService: RevenueService,
        private productCategoryService: ProductCategoryService,
        private printService: PrintService
    ) {
        super();
        this.defaultFilters = {
            from: null,
            to: null,
            productCategoryId: null,
            predefinedPeriod: "custom",
        };
        this.filters = {
            from: null,
            to: null,
            productCategoryId: null,
            predefinedPeriod: "custom",
        };
        this.resetFilters(false);

        this.dataSource = new RevenueDataSource(this.revenueService);
    }

    ngAfterViewInit() {
        this.loadProductCategories();
        this.prepareDataLoading();
        this.loadData(new SortInfo("count", SortInfo.DIR_DESC));
    }

    loadProductCategories(): void {
        this.productCategoryService.getSimpleList().subscribe((categories) => {
            this.categories = categories;
        });
    }

    prepareDataLoading() {
        merge(
            this.sort.sortChange,
            Observable.fromEvent(this.search.nativeElement, "keyup")
                .debounceTime(150)
                .distinctUntilChanged(),
            this.dataChangedEventSubject
        ).subscribe(() => {
            if (!this.dataSource) {
                return;
            }

            this.loadData(new SortInfo(this.sort.active, this.sort.direction));
        });
    }

    loadData(sort: SortInfo) {
        console.log(sort);
        this.dataSource.loadPage(
            new Pagination(
                this.pageSize,
                this.pageSize * this.initialPageIndex
            ),
            sort,
            this.getFilters()
        );
    }

    getFilters() {
        const filters: Filter[] = [];

        if (this.filters.from) {
            filters.push(new Filter("from", this.filters.from.toISOString()));
        }
        if (this.filters.to) {
            filters.push(new Filter("to", this.filters.to.toISOString()));
        }

        if (
            this.filters.productCategoryId !== null &&
            this.filters.productCategoryId
        ) {
            filters.push(
                new Filter(
                    "product_category_id",
                    this.filters.productCategoryId
                )
            );
        }

        if (this.search.nativeElement.value.trim().length > 0) {
            filters.push(new Filter("search", this.search.nativeElement.value));
        }

        return filters;
    }

    setPredefinedPeriod(period: string): void {
        this.filters.predefinedPeriod = period;

        const now = new Date();

        switch (period) {
            case "lastMonth":
                const lastMonth = new Date(
                    now.getFullYear(),
                    now.getMonth() - 1,
                    1
                );
                const lastMonthEnd = new Date(
                    now.getFullYear(),
                    now.getMonth(),
                    0
                );
                this.filters.from = lastMonth;
                this.filters.to = lastMonthEnd;
                break;

            case "thisYear":
                const yearStart = new Date(now.getFullYear(), 0, 1);
                const yearEnd = new Date(now.getFullYear(), 11, 31);
                this.filters.from = yearStart;
                this.filters.to = yearEnd;
                break;

            case "custom":
                // Keep current dates, just change the period
                break;
        }

        this.reloadPage();
    }

    onDateChange(): void {
        // When user manually changes dates, switch to custom period
        this.filters.predefinedPeriod = "custom";
        this.reloadPage();
    }

    printReport(): void {
        const filters: Filter[] = [];

        if (this.filters.from) {
            filters.push(new Filter("from", this.filters.from.toISOString()));
        }
        if (this.filters.to) {
            filters.push(new Filter("to", this.filters.to.toISOString()));
        }

        if (
            this.filters.productCategoryId !== null &&
            this.filters.productCategoryId
        ) {
            filters.push(
                new Filter(
                    "product_category_id",
                    this.filters.productCategoryId
                )
            );
        }

        if (this.search.nativeElement.value.trim().length > 0) {
            filters.push(new Filter("search", this.search.nativeElement.value));
        }

        const url = this.printService.getRevenueReportPrintUrl(filters);
        window.open(url, "_blank");
    }

    exportXlsx(): void {
        const filters: Filter[] = [];

        if (this.filters.from) {
            filters.push(new Filter("from", this.filters.from.toISOString()));
        }
        if (this.filters.to) {
            filters.push(new Filter("to", this.filters.to.toISOString()));
        }

        if (
            this.filters.productCategoryId !== null &&
            this.filters.productCategoryId
        ) {
            filters.push(
                new Filter(
                    "product_category_id",
                    this.filters.productCategoryId
                )
            );
        }

        if (this.search.nativeElement.value.trim().length > 0) {
            filters.push(new Filter("search", this.search.nativeElement.value));
        }

        const url = this.printService.getRevenueReportXlsxUrl(filters);
        window.open(url, "_blank");
    }
}



// WEBPACK FOOTER //
// /app/src/RevenueModule/RevenuePerProductComponent/revenue-per-product.component.ts